import script from "./ColorsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorsList.vue?vue&type=script&setup=true&lang=ts"

import "./ColorsList.scss?vue&type=style&index=0&id=665d6b42&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-665d6b42"]])

export default __exports__